/* eslint-disable no-unused-vars */
import React from 'react';
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  IconButton,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { Trash, UserPlus } from 'phosphor-react';
import AlertModal from '../../../AlertModal';
import { InputForm } from '../InputForm';
import { MaskedInputForm } from '../MaskedInputForm';
import { SelectInputForm } from '../SelectInputForm';
import { FormRow } from '../../../ui/Form';

export const CustomParentsInputForm = ({
  name,
  label,
  optionsKinship,
  setFormValue,
  register,
  control,
  watch,
  errors,
  isDisabled,
}: any) => {
  const parents = watch(name) ?? [];

  const handleAddParent = () => {
    setFormValue(name, [
      ...parents,
      {
        name: '',
        email: '',
        cell_phone: '',
        kinship: null,
      },
    ]);
  };

  const deleteParent = (index: number) => {
    setFormValue(
      name,
      parents.filter((_, idx) => idx !== index)
    );
  };
  const { isOpen, onClose } = useDisclosure();

  const ButtonOpen = (props: any) => (
    <IconButton
      variant="ghost"
      size="sm"
      color="content.subtle"
      _hover={{ bg: 'state.destructiveSurface', color: 'state.destructive' }}
      aria-label="Remover responsável"
      icon={<Trash size={16} />}
      isDisabled={isDisabled}
      {...props}
    />
  );

  return (
    <FormControl isRequired isInvalid={!!errors[name]}>
      {label && <FormLabel>{label}</FormLabel>}

      <Flex direction="column" gap="12px">
        {parents.map((_, idx) => (
          <Box
            key={idx as number}
            p="16px"
            border="1px solid"
            borderColor="line.hairline"
            borderRadius="lg"
            bg="surface.base"
          >
            <Flex align="center" justify="space-between" mb="12px">
              <Text fontSize="13px" lineHeight="20px" fontWeight={500} color="content.strong">
                Responsável {idx + 1}
              </Text>
              <AlertModal
                isOpenSecondary={isOpen}
                onCloseSecondary={onClose}
                msgStatus="warning"
                ButtonOpen={ButtonOpen}
                ConfirmButton={
                  <Button
                    w="200px"
                    onClick={() => {
                      onClose();
                      deleteParent(idx);
                    }}
                  >
                    Confirmar exclusão
                  </Button>
                }
              />
            </Flex>
            <FormRow>
              <InputForm
                name={`${name}.${idx}.name`}
                label="Nome"
                placeholder="Nome do responsável"
                isRequired
                isDisabled={isDisabled}
                register={register}
                errors={errors}
              />
              <InputForm
                name={`${name}.${idx}.email`}
                label="Email"
                placeholder="Email do responsável"
                isRequired
                isDisabled={isDisabled}
                register={register}
                errors={errors}
              />
              <MaskedInputForm
                name={`${name}.${idx}.cell_phone`}
                label="Telefone"
                placeholder="Telefone do responsável"
                isRequired
                isDisabled={isDisabled}
                control={control}
                errors={errors}
                mask="(99) 99999-9999"
              />
              <SelectInputForm
                name={`${name}.${idx}.kinship`}
                label="Parentesco"
                options={optionsKinship}
                placeholder="Selecione o parentesco"
                isRequired
                isDisabled={isDisabled}
                control={control}
                errors={errors}
              />
            </FormRow>
          </Box>
        ))}

        {parents.length === 0 && (
          <Text fontSize="13px" lineHeight="20px" color="content.body">
            Nenhum responsável atribuído. Adicione ao menos um responsável para o aluno.
          </Text>
        )}

        <Flex>
          <Button
            type="button"
            variant="outline"
            size="sm"
            leftIcon={<UserPlus size={14} />}
            onClick={handleAddParent}
            isDisabled={isDisabled}
          >
            Adicionar responsável
          </Button>
        </Flex>

        {errors[name] && <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>}
      </Flex>
    </FormControl>
  );
};
